import { Dialog } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import CenteredModal from "./CenteredModal";
import AppButton from "../buttons/AppButton";
type AlertProps = {
  isOpen: boolean;
  onClose: (key: boolean) => void;
};
export default function TermsAndConditionModal(props: AlertProps) {
  const { isOpen, onClose } = props;
  const LocalBasePath = "terms";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const navigateTo = (url: string) => {
    window.open(url, "_blank");
  };
  return (
    <CenteredModal classStyles="p-0 pt-6" setOpen={onClose} open={isOpen}>
      <div className="sm:w-[512px] ">
        <div className="mb-3 bg-white">
          <div className="sm:flex  px-6 gap-4 sm:items-start">
            <div className="flex flex-col gap-4 w-full">
              <Dialog.Title
                as="h2"
                className="flex gap-3 text-base leading-5  font-medium text-gray-700"
              >
                {t("termsAndCondition")}
              </Dialog.Title>
              <div className="flex flex-col gap-4">
                <div className="w-full flex flex-col gap-3 text-gray-400 text-sm">
                  <p>
                    إننا ننشئ مجموعة من الخدمات من شأنها أن تساعد ملايين الأشخاص
                    بصفة يومية على استكشاف العالم والتفاعل معه بطرق جديدة.
                    وتشتمل خدماتنا على:
                  </p>
                  <ul className="ltr:pl-7 rtl:pr-7  list-disc">
                    <li>
                      <p>
                        برامج Google ومواقعها وأجهزتها، مثل ث وYouTube وGoogle
                        Home
                      </p>
                    </li>
                    <li>
                      <p>
                        برامج Google ومواقعها وأجهزتها، مثل &;البحث وYouTube
                        وGoogle Home
                      </p>
                    </li>
                    <li>
                      <p>
                        برامج Google ومواقعها وأجهزتها، مثل البحث وYouTube
                        وGoogle Home
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="w-full flex flex-col gap-2 text-gray-400 text-sm">
                  <p>
                    يمكنك استخدام خدماتنا بطرق شتى لإدارة خصوصيتك. على سبيل
                    المثال، يمكنك الاشتراك في حساب Google إذا أردت إنشاء محتوى
                    وإدارته، مثل الرسائل الإلكترونية والصور، أو إذا أردت عرض
                    مزيد من نتائج البحث ذات الصلة. يمكنك أيضًا استخدام الكثير من
                    خدمات Google بدون تسجيل الدخول إلى حسابك أو بدون إنشاء حساب
                    من الأساس، مثل البحث على Google أو مشاهدة فيديوهات YouTube.
                    كما يمكنك اختيار تصفّح الويب بخصوصية تامة باستخدام متصفّح
                    Chrome في "وضع التصفّح المتخفي". وبإمكانك، في مختلف خدماتنا،
                    ضبط إعدادات الخصوصية للتحكم في المعلومات التي نجمعها وكيفية
                    استخدامها.
                  </p>

                  <p>
                    للمساعدة في شرح الأمور بأكبر قدر ممكن من الوضوح أضفنا
                    الأمثلة والفيديوهات التوضيحية والتعريفات بخصوص
                    <span
                      onClick={() => navigateTo("")}
                      className="text-brandblue-500 mx-1.5 cursor-pointer underline"
                    >
                      {" "}
                      لمصطلحات{" "}
                    </span>
                    الرئيسية. وإذا لديك أي أسئلة بشأن سياسة الخصوصية هذه، يمكنك
                    الاتصال بنا
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col mt-6 border-t border-gray-200  py-2 px-6 gap-3 sm:flex-row-reverse">
          <AppButton onClick={() => onClose(true)} buttonShape="primary">
            {t("agree")}
          </AppButton>
          <AppButton onClick={() => onClose(false)} buttonShape="secondary">
            {t("cancel")}
          </AppButton>
        </div>
      </div>
    </CenteredModal>
  );
}
